import { HttpResponseList } from 'shell/models/http-response';
import { AxiosResponse } from 'axios';
import { ResponseAmount } from 'shell/models/response-amount';
import { ResearchAmountVM, BodyResearchAmountVM } from 'front-office/view-models/research-amount';
import { DateTime } from 'luxon';

export const transformerListAmount = (
  response: AxiosResponse<HttpResponseList<ResponseAmount>>
): ResearchAmountVM => {
  const data = response.data.payload.list || [];

  const list: Array<BodyResearchAmountVM> = data.map(
    (item) =>
      ({
        code: item.key?.codiceImportoPagamento || undefined,
        amount: item.importoPagamento?.toString() || undefined,
        description: item.descrizioneImportoPagamento || undefined,
        dateFrom: item.dataInizioValidita
          ? DateTime.fromISO(item.dataInizioValidita).toFormat('dd/MM/yyyy')
          : undefined,
        dateTo: item.dataFineValidita
          ? DateTime.fromISO(item.dataFineValidita).toFormat('dd/MM/yyyy')
          : undefined,
      } as BodyResearchAmountVM)
  );

  return {
    table: {
      list,
    },
  };
};
